/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProposalSummaryFundDetailsCollectiveInvestments
 */
export interface ProposalSummaryFundDetailsCollectiveInvestments {
    /**
     * 
     * @type {number}
     * @memberof ProposalSummaryFundDetailsCollectiveInvestments
     */
    assetCode?: number;
    /**
     * 
     * @type {string}
     * @memberof ProposalSummaryFundDetailsCollectiveInvestments
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof ProposalSummaryFundDetailsCollectiveInvestments
     */
    cashPercentage?: number;
    /**
     * 
     * @type {number}
     * @memberof ProposalSummaryFundDetailsCollectiveInvestments
     */
    unitTransferPercentage?: number;
    /**
     * 
     * @type {number}
     * @memberof ProposalSummaryFundDetailsCollectiveInvestments
     */
    totalOnceOffPercentage?: number;
    /**
     * 
     * @type {number}
     * @memberof ProposalSummaryFundDetailsCollectiveInvestments
     */
    totalEstimatedAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof ProposalSummaryFundDetailsCollectiveInvestments
     */
    totalCashAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof ProposalSummaryFundDetailsCollectiveInvestments
     */
    recurringPercentage?: number;
    /**
     * 
     * @type {number}
     * @memberof ProposalSummaryFundDetailsCollectiveInvestments
     */
    recurringAmount?: number;
}

/**
 * Check if a given object implements the ProposalSummaryFundDetailsCollectiveInvestments interface.
 */
export function instanceOfProposalSummaryFundDetailsCollectiveInvestments(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ProposalSummaryFundDetailsCollectiveInvestmentsFromJSON(json: any): ProposalSummaryFundDetailsCollectiveInvestments {
    return ProposalSummaryFundDetailsCollectiveInvestmentsFromJSONTyped(json, false);
}

export function ProposalSummaryFundDetailsCollectiveInvestmentsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProposalSummaryFundDetailsCollectiveInvestments {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'assetCode': !exists(json, 'AssetCode') ? undefined : json['AssetCode'],
        'name': !exists(json, 'Name') ? undefined : json['Name'],
        'cashPercentage': !exists(json, 'CashPercentage') ? undefined : json['CashPercentage'],
        'unitTransferPercentage': !exists(json, 'UnitTransferPercentage') ? undefined : json['UnitTransferPercentage'],
        'totalOnceOffPercentage': !exists(json, 'TotalOnceOffPercentage') ? undefined : json['TotalOnceOffPercentage'],
        'totalEstimatedAmount': !exists(json, 'TotalEstimatedAmount') ? undefined : json['TotalEstimatedAmount'],
        'totalCashAmount': !exists(json, 'TotalCashAmount') ? undefined : json['TotalCashAmount'],
        'recurringPercentage': !exists(json, 'RecurringPercentage') ? undefined : json['RecurringPercentage'],
        'recurringAmount': !exists(json, 'RecurringAmount') ? undefined : json['RecurringAmount'],
    };
}

export function ProposalSummaryFundDetailsCollectiveInvestmentsToJSON(value?: ProposalSummaryFundDetailsCollectiveInvestments | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'AssetCode': value.assetCode,
        'Name': value.name,
        'CashPercentage': value.cashPercentage,
        'UnitTransferPercentage': value.unitTransferPercentage,
        'TotalOnceOffPercentage': value.totalOnceOffPercentage,
        'TotalEstimatedAmount': value.totalEstimatedAmount,
        'TotalCashAmount': value.totalCashAmount,
        'RecurringPercentage': value.recurringPercentage,
        'RecurringAmount': value.recurringAmount,
    };
}

